import { Modal } from "antd";
import conf from "../conf/config"
import { Format, Method, RequestKind } from "../conf/interface";
import requestkind from "../conf/requestkind";
import { message } from 'antd';
// var md5 = require('md5');
// 对api的请求做统一封装管理



const request = async (data: any, params: any, requestkind: RequestKind): Promise<any> => {
    // let diff = localStorage.getItem('diff') || ""
    let url = `${conf.apibase}${requestkind.url}`
    // 从本地存储里获得token，并设置Bearer风格的jwt。


    try {
        const session: any = sessionStorage.getItem(`oidc.user:${conf.oidcConfig.authority}:CreditCheckExternal-UI`)
        const { access_token, expires_at, token_type } = JSON.parse(session)
        if (expires_at * 1000 - Date.now() <= 0) {
            sessionStorage.clear()
            window.location.reload()
        }
        const headers: any = {
            'Authorization': `${token_type} ${access_token}`
        }

        console.log('headers', headers)

        // 根据类型组装headers中的类型
        switch (requestkind.format) {
            case Format.json:
                headers['Accept'] = 'application/json'
                headers['Content-Type'] = 'application/json'
                break;
            case Format.text:
                headers['Accept'] = 'text/plain'
                headers['Content-Type'] = 'text/plain'
                break;
            case Format.blob:
                headers['Accept'] = 'application/octet-stream'
                headers['Content-Type'] = 'application/octet-stream'
                break;
            default:
                break;
        }

        const settings: RequestInit = {
            method: requestkind.method,
            headers: headers
        };

        console.log('settings', settings)

        if (requestkind.method === Method.POST && data) {
            // if (requestkind.format === Format.json) {
            //     settings['body'] = JSON.stringify(data)
            // }
            if (requestkind.format === Format.form) {
                settings['body'] = data
            } else {
                //default json
                settings['body'] = JSON.stringify(data)
            }
        }

        if (params) {
            let paramsArray: any[] = [];
            //拼接参数  
            Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
            if (url.search(/\?/) === -1) {
                url += '?' + paramsArray.join('&')
            } else {
                url += '&' + paramsArray.join('&')
            }
        }

        // const difftext = md5(url) + md5(settings)

        // if (difftext===diff && requestkind.method === Method.POST && data) {
        //     console.log('重复提交已被忽略')
        //     // message.error("重复提交已被忽略")
        //     return false;
        // }

        // localStorage.setItem('diff',difftext)
        const res = await fetch(url, settings);




        console.log('response!', res)
        if (res.status === 500 || res.status === 502) {
            Modal.error({
                title: 'APi错误！',
                content: res.status
            });
        }

        if (res.status === 403) {
            console.log(403)
            // Modal.error({
            //     title: '请退出重新登录',
            //     content: res.status
            // });
            sessionStorage.clear()
            message.error("403 权限不够请重登录")
            // setTimeout(() => {
            //     window.location.reload()
            // }, 1000);

        }

        if (requestkind.format === Format.blob) {
            // res.headers.forEach(console.log);
            res.headers.forEach((value, name) => {
                console.log(name + ": " + value);
            });
            const headers = res.headers
            const blob = await res.blob()
            return { headers, blob }
        } else {
            return await res.json()
        }
    } catch (error) {
        console.log('error in requests', error)
        // Modal.error({
        //     title: '错误！',
        //     content: error.msg
        // });
    }


}

export { request, requestkind }
